import refuelingMochipayTutorial01LottieJson from './assets/json/refueling-mochipay-tutorial01.json';
import refuelingMochipayTutorial02LottieJson from './assets/json/refueling-mochipay-tutorial02.json';
import refuelingMochipayTutorial03LottieJson from './assets/json/refueling-mochipay-tutorial03.json';
import refuelingBarcodeTutorial01LottieJson from './assets/json/refueling-barcode-tutorial01.json';
import refuelingBarcodeTutorial02LottieJson from './assets/json/refueling-barcode-tutorial02.json';
import refuelingBarcodeTutorial03LottieJson from './assets/json/refueling-barcode-tutorial03.json';
import refuelingAutopassTutorial01LottieJson from './assets/json/refueling-autopass-tutorial01.json';
import refuelingAutopassTutorial02LottieJson from './assets/json/refueling-autopass-tutorial02.json';
import refuelingAutopassTutorial03LottieJson from './assets/json/refueling-autopass-tutorial03.json';
import parkingAutopassTutorial01LottieJson from './assets/json/parking-autopass-tutorial01.json';
import parkingAutopassTutorial02LottieJson from './assets/json/parking-autopass-tutorial02.json';
import parkingAutopassTutorial03LottieJson from './assets/json/parking-autopass-tutorial03.json';

export const REFUELING_TUTORIAL_VERTICAL_LIST_DATA = {
  mochipay: [
    {
      id: 'refueling_mochipay_1',
      lottie: refuelingMochipayTutorial01LottieJson,
      content: '前往麻吉付加油站，加油前，與加油員喊聲「我要用麻吉付」與統編。',
    },
    {
      id: 'refueling_mochipay_2',
      lottie: refuelingMochipayTutorial02LottieJson,
      content: '開啟加油授權付款畫面，點擊「同意付款」完成。',
    },
    {
      id: 'refueling_mochipay_3',
      lottie: refuelingMochipayTutorial03LottieJson,
      content: '加油完成，部分加油站發票自動存入設定載具，現場免拿發票。',
    },
  ],
  barcode: [
    {
      id: 'refueling_barcode_1',
      lottie: refuelingBarcodeTutorial01LottieJson,
      content:
        '前往條碼付加油站，於加油完成時，告知站員「我要用條碼付」與統編。 ',
    },
    {
      id: 'refueling_barcode_2',
      lottie: refuelingBarcodeTutorial02LottieJson,
      content: '出示「條碼付款」畫面，掃描付款條碼與發票載具，完成付款。',
    },
    {
      id: 'refueling_barcode_3',
      lottie: refuelingBarcodeTutorial03LottieJson,
      content: '發票將存入您掃描的載具，開立統編請現場索取發票。',
    },
  ],
  autopass: [
    {
      id: 'refueling_autopass_1',
      lottie: refuelingAutopassTutorial01LottieJson,
      content: '申請開通快速通，等待車牌綁定完成。',
    },
    {
      id: 'refueling_autopass_2',
      lottie: refuelingAutopassTutorial02LottieJson,
      content: '前往快速通加油站，加油前，與加油員喊聲「我要用快速通」與統編。',
    },
    {
      id: 'refueling_autopass_3',
      lottie: refuelingAutopassTutorial03LottieJson,
      content: '加油完成，隔日扣款。現場開立發票，免簽單據。',
    },
  ],
} as const;

export const PARKING_TUTORIAL_VERTICAL_LIST_DATA = {
  autopass: [
    {
      id: 'parking_autopass_1',
      lottie: parkingAutopassTutorial01LottieJson,
      content: '前往快速通停車場，車牌辨識進場，免取票卡。',
    },
    {
      id: 'parking_autopass_2',
      lottie: parkingAutopassTutorial02LottieJson,
      content: '進場後，即時追蹤停車時數與金額。（部分公有場不提供進場資訊）',
    },
    {
      id: 'parking_autopass_3',
      lottie: parkingAutopassTutorial03LottieJson,
      content:
        '出場時，車牌辨識自動付款，扣款結果即時通知。（使用商家消費折抵，請至繳費機付款）',
    },
  ],
} as const;
